import { useTranslation } from 'react-i18next';
import { mockUploadedFiles } from '@/mocks/dashboard';
import DashboardFiles from './components/DashboardFiles';

export default function FilesPage() {
  const { t } = useTranslation('dashboard');
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-xl md:text-2xl font-bold text-ink-700">{t('dashboard.files.title')}</h1>
        <p className="text-sm text-ink-300 mt-1">Uploaded documents and references</p>
      </div>
      <DashboardFiles files={mockUploadedFiles} />
    </div>
  );
}